import "../styles/LegalPages.css";

function CookiesPage() {

  return (

    <div className="legal-page">

      <div className="legal-container">

        <h1>

          Politique relative aux cookies

        </h1>

        <p>

          Dernière mise à jour : Juin 2026

        </p>

        <section>

          <h2>

            Que sont les cookies ?

          </h2>

          <p>

            Les cookies sont de petits fichiers enregistrés sur votre appareil afin d'améliorer votre expérience de navigation sur FootVision Live.

          </p>

        </section>

        <section>

          <h2>

            Cookies utilisés

          </h2>

          <ul>

            <li>Connexion sécurisée</li>

            <li>Préférences utilisateur</li>

            <li>Statistiques d'utilisation</li>

            <li>Amélioration des performances</li>

            <li>Publicités personnalisées (Google AdSense)</li>

          </ul>

        </section>

        <section>

          <h2>

            Gestion des cookies

          </h2>

          <p>

            Vous pouvez supprimer ou bloquer les cookies depuis les paramètres de votre navigateur. Certaines fonctionnalités de FootVision Live pourraient cependant ne plus fonctionner correctement.

          </p>

        </section>

      </div>

    </div>

  );

}

export default CookiesPage;